import fetcher from "@utils/Fetcher";
import useSWR from "swr";

export const useGeneralStatistics = (config) => {
    return useSWR("dashboard/general_info", fetcher, config);
};
